export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/sharedworker.97d69c64.worker.js");
}
